import axiosInstance from "../axiosConfig";
import { ADMIN_API_URL } from "../config/apiParams";

export const fetchOrganisations = async ({queryKey}) => {
  const {organisationId, projectId, access_token, token_type} = queryKey[1]
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });
  if (response.status !== 200) {
    throw new Error('No response from the network');
  }

  // console.log('resoponse from Organisations RQ', response);
  return response.data;
}

export const fetchUserOrganisations = async ({queryKey}) => {
  const { access_token, token_type} = queryKey[1]
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  });
  if (response.status !== 200) {
    throw new Error('No response from the network');
  }

  // console.log('resoponse from Organisations RQ', response);
  return response.data;
}

export const createNewOrganisation = async ({org, access_token, token_type}) => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/`,
    method: "POST",
    data: org,
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  }); 

  return response.data;
}

export const getOrganisation = async ({queryKey}) => {
  const {selectedOrg, access_token, token_type} = queryKey[1];

  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/${selectedOrg["Org ID"]}`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  }); 

  return response.data;
}

export const getOrgUsers = async ({queryKey}) => {
  const {selectedOrg, access_token, token_type} = queryKey[1];

  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/${selectedOrg["Org ID"]}/users`,
    method: "GET",
    headers: {
      'Authorization': `${token_type} ${access_token}`
    },
  }); 

  return response.data;
}

export const getOrgRoles = async () => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/roles/`,
    method: "POST"
  }); 

  return response.data;
}

export const updateOrganisation = async ({selectedOrg, payload, access_token, token_type}) => {
  const response = await axiosInstance({
    url: `${ADMIN_API_URL}/organisation/${selectedOrg["Org ID"]}`,
    method: "POST",
    data: payload,
    headers: {
      'Authorization': `${token_type} ${access_token}`
    }
  }); 

  return response.data;
}